import { isExcluded } from './isExcluded';

export const getStringValue = val => (isExcluded(val) ? val.substring(1) : val);
